import { Editor } from '@tiptap/core';
import { ReactRenderer } from '@tiptap/react';
import { CommandsMenu } from '../../private/components/CommandsMenu';
import { commandExtension } from './command';
import { defaultCommands } from './constants';

const renderItems = () => {
  let component: ReactRenderer | null = null;

  const onClose = () => {
    component?.destroy();
  };

  return {
    onStart: (props: { editor: Editor; clientRect: DOMRect }) => {
      component = new ReactRenderer(CommandsMenu, {
        props: { ...props, onClose },
        editor: props.editor,
      });
    },
    onUpdate: (props: { editor: Editor; clientRect: DOMRect }) => {
      component?.updateProps(props);
    },
    onExit: () => {
      onClose();
    },
  };
};

export const slashCommandExtension = commandExtension.configure({
  commands: defaultCommands,
  suggestion: {
    items: ({ query, editor }) =>
      editor.commands.getSlashCommandsItems().filter((item) => {
        if (typeof query === 'string' && query.length > 0) {
          const search = query.toLowerCase();
          return (
            item.title.toLowerCase().includes(search) ||
            item.description.toLowerCase().includes(search) ||
            (item.searchTerms &&
              item.searchTerms.some((term: string) => term.includes(search)))
          );
        }
        return true;
      }),
    // @ts-expect-error
    render: renderItems,
  },
});
